import {MergeOptions} from './core/objects';
import {getWindowHostname} from "./core/browser";
import {substitute} from "./core/strings";

// expected settings injected by build compilation
interface SiteSettingsProps {
    baseHost: string;
    usersUri: string;
    mainUri: string;
    stompUri: string;
    rpcBaseTopic: string;
    calibrationUri: string;
    readingsUri: string;
    readingsPollDelay: number;
    keycloakUri: string;
    partnerId: Number;
    debug: boolean;
}

// set of URIs available for the site
interface SiteUriData {
    host: string;
    main: string;
    users: string;
    keycloak: string;
    stomp: string;
    calibration: string;
    readings: string;
}

interface SiteRpcData {
    storeExportTopic: string;
}

declare var SITE_SETTINGS: SiteSettingsProps;

/**
 * Set of site components that are limited to certain users.
 */
export enum PrivilegedSiteComponent {
    CabinetPermissions,
    UserManagement,
    Calibration,
    Admin,
}

/**
 * Container for all global site settings
 */
export class SiteSettingsWrapper {
    readonly readingsPollDelay: number;
    readonly partnerId: Number;
    readonly debug: boolean;
    private uriData: SiteUriData;

    constructor(uriData?: SiteUriData) {
        this.uriData = uriData;
        this.readingsPollDelay = SITE_SETTINGS.readingsPollDelay;
        this.partnerId = SITE_SETTINGS.partnerId;
        this.debug = SITE_SETTINGS.debug;
    }

    get uri() : SiteUriData {
        if (!this.uriData) {
            let hostname = getWindowHostname();
            let subData = {
                hostname: hostname.replace('frontend.', '')
            };

            this.uriData = {
                host: substitute(SITE_SETTINGS.baseHost, subData),
                main: substitute(SITE_SETTINGS.mainUri, subData),
                users: substitute(SITE_SETTINGS.usersUri, subData),
                keycloak: substitute(SITE_SETTINGS.keycloakUri, subData),
                stomp: substitute(SITE_SETTINGS.stompUri, subData),
                calibration: substitute(SITE_SETTINGS.calibrationUri, subData),
                readings: substitute(SITE_SETTINGS.readingsUri, subData)
            };
        }
        return this.uriData;
    }

    get rpc() : SiteRpcData {
        return {
            storeExportTopic: SITE_SETTINGS.rpcBaseTopic + '.readings_report'
        };
    }
}

// all settings global for using the site
export let SiteSettings = new SiteSettingsWrapper();
export const ACTION_TYPE_STATE_MERGE = 'state_merge';

export interface MergeAction {
    type: string;
    newState: any;
    mergeOptions?: MergeOptions;
}

export function createMergeAction(name: string,
                                  newState: any,
                                  mergeOptions?: MergeOptions) : MergeAction {
    return {
        type: `${ACTION_TYPE_STATE_MERGE}:${name}`,
        newState: newState,
        mergeOptions: mergeOptions
    };
}
